<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini">
			<div class="o-stack__cell" style="padding: 0px">
				<h5 class="card-title primary-color">{{ sectiontitle }}</h5>
				<span *ngIf="hasData">
					<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank">
						<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNGIcon"></i>
						<svg *ngIf="downloadConfiguration.downloadPNGIcon" width="14px" height="17px" viewBox="0 0 14 17">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<path
									d="M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 Z"
									class="downloadSvgIcon"
									fill-rule="nonzero"
								></path>
							</g>
						</svg>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center legend-list" *ngIf="hasData">
				<div class="social-demographic-gender-list-cntr">
					<ul class="gender-div">
						<li
							*ngFor="let legendItem of legend; let index = index"
							class="social-demographic-gender-list-item"
							[ngClass]="currentLegendItem == legendItem.value ? 'activeGender primary-color' : ''"
							(click)="updateLegend(legendItem.value)"
						>
							<div>{{ legendItem.displayName }}</div>
							<i
								*ngIf="currentLegendItem == legendItem.value"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '16px', color: colorPalette.primaryColor, float: 'right' }"
							></i>
						</li>
					</ul>
				</div>
			</div>
			<div class="chart-div" *ngIf="hasData">
				<div id="chartElement"></div>
			</div>
			<div class="map-no-data" *ngIf="!hasData">No Data to Display</div>
		</div>
	</div>
</div>
